import React, { useMemo, useContext } from 'react'
import { getMilestoneTitle } from 'src/screens/shared/implementation/details/milestone/utils/MilestoneUtils'
import { Milestone, Milestone_Config } from 'src/@types/graphql'
import { SupportedLocale } from 'src/@types'

const MilestoneTitleContext = React.createContext<string | null>(null)

interface MilestoneTitleProviderProps {
  children: React.ReactNode
  milestoneConfiguration: Milestone_Config | null | undefined
  locale: SupportedLocale
  milestone?: Milestone
}

export function MilestoneTitleContextProvider({
  children,
  milestoneConfiguration,
  locale,
  milestone,
}: MilestoneTitleProviderProps) {
  const title = useMemo(() => {
    if (!milestoneConfiguration) return ''

    const baseTitle = getMilestoneTitle(milestoneConfiguration, locale)
    return `${baseTitle} ${milestone?.year_in_focus ?? ''}`
  }, [milestoneConfiguration, locale, milestone])

  return <MilestoneTitleContext.Provider value={title}>{children}</MilestoneTitleContext.Provider>
}

export function useMilestoneTitle(): string {
  return useContext(MilestoneTitleContext) ?? ''
}
